<div *ngIf="categoryList.length > 0" class="btn-flex-categoria">
  <div class="flex-item" *ngFor="let item of categoryList; let i = index; let last = last">
    <div class="btn" style="width: 1%;" [style.background-color]="last ? styleConfig.endBarColor : styleConfig.barColor"
      [style.color]="styleConfig.color" (click)="goToCategory(item.id)">{{ item.name }}</div>
  </div>
</div>
<nb-card *ngIf="displayCarousel()" class="banner-card">
  <p-carousel [value]="carousel" [autoplayInterval]="5000" [circular]="true">
    <ng-template let-item pTemplate="item" class="image-item">
      <img [src]="item.src" alt="Banner" (click)="goToUrl(item.urlBanner)" class="logo-image">
    </ng-template>
  </p-carousel>
</nb-card>
<product-grid *ngIf="offerPanel === 'ABOVE'" [(products)]="pagedOfferProducts" [totalRecords]="totalOfferSize"
  [category]="offer" (onPageEmit)="pageEvent($event, true)" (onSortOrderEmit)="sortEvent($event, true)"
  [sortOption]="sortOrder" [firstLoading]="firstLoadingOfferProducts"></product-grid>

<product-grid [(products)]="pagedProducts" [totalRecords]="totalSize" [category]="featuredCategory"
  (onPageEmit)="pageEvent($event)" (onSortOrderEmit)="sortEvent($event)" [sortOption]="sortOrder"
  [firstLoading]="firstLoadingFeaturedProducts"></product-grid>

  <product-grid *ngIf="offerPanel === 'BELOW'" [(products)]="pagedOfferProducts" [totalRecords]="totalOfferSize"
  [category]="offer" (onPageEmit)="pageEvent($event, true)" (onSortOrderEmit)="sortEvent($event, true)"
  [sortOption]="sortOrder" [firstLoading]="firstLoadingOfferProducts"></product-grid>